export const LINKS = {
    PRIVACY_POLICY: "/privacy-policy.html",
    TERM_AND_CONDITION: "/terms-and-conditions.html",
};
